//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.wintermar.inspection.graphql.type.DeleteInspectionCommandInput
import kotlin.IllegalStateException

public object DeleteInspectionCommandInput_InputAdapter : Adapter<DeleteInspectionCommandInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): DeleteInspectionCommandInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: DeleteInspectionCommandInput,
  ) {
    writer.name("inspectionId")
    AnyAdapter.toJson(writer, customScalarAdapters, value.inspectionId)
  }
}
